<template>
  <div class="page reserve">
    <div class="icon icon-logo abs"></div>
    <div class="footer-logo">
      <i class="icon icon-mg-logo"></i>
      <i class="icon icon-vip"></i>
    </div>
    <div class="icon icon-paper abs"></div>
    <div class="icon icon-cat2 abs"></div>
    <div class="icon icon-cat3 abs"></div>
    <div class="pannel-wrapper">
      <div class="pannel">
        <div class="pannel-content">
          <p>让我们说悄悄话，说到沙哑</p>
          <p>这里整夜有光，如果你也怕黑的话</p>
        </div>
      </div>
    </div>
    <div class="btn-wrapper">
      <div class="btn" @click="onClickBtn('appoint')">START</div>
    </div>
    <jump-dialog :showDialog.sync="isShowJump" />
  </div>
</template>

<script>
import JumpDialog from '@/components/common/JumpDialog';
import LoginSDK from "@/utils/login";
import Env from '@/utils/env'

export default {
  components: {
    JumpDialog,
  },
  data() {
    return {
      isShowJump: false,
    };
  },
  methods: {
    onClickBtn(target) {
      if (!Env.isMgtvApp && !this.isDev) {
        this.isShowJump = true;
        return;
      }
      const { uuid } = this.dataStore.getInfo();
      const data = JSON.stringify(this.dataStore.getInfo());
      if (!uuid) {
        LoginSDK.login();
        return;
      }
      this.$router.push({ name: target });
    },
  }
};
</script>

<style lang="scss">
@import "~@/assets/mixins.scss";

.reserve{
  .btn {
    &-wrapper {
      position: relative;
      @include px2vw(width, 187);
      @include px2vw(padding-top, 315);
      margin: 0 auto;
    }
    background-image: url("~@/assets/img/btn.png");
    &.disabled {
      background-image: url("~@/assets/img/btn-dis.png");
    }
    @include px2vw(width, 187);
    @include px2vw(height, 81);
    @include px2vw(line-height, 81);
    @include px2vw(font-size, 35);
    font-weight: bold;
    & + .btn {
      @include px2vw(margin-top, 30);
    }
  }
  .pannel {
    &-wrapper {
      @include px2vw(padding-top, 300);
      @include px2vw(font-size, 24);
      @include px2vw(line-height, 40);
      color: #333333;
    }
    &-content {
      line-height: 1.5;
    }
    position: relative;
    background-image: url("~@/assets/img/panel-tip2.png");
    background-size: cover;
    @include px2vw(width, 626);
    @include px2vw(height, 379);
    @include px2vw(padding-left, 195);
    @include px2vw(padding-top, 184);
    margin: 0 auto;
  }

  .icon {
    &-logo {
      @include px2vw(top, 20);
      @include px2vw(left, 30);
    }
    &-cat2 {
      @include px2vw(top, 409);
      right: 0;
      z-index: 10;
    }
    &-cat3 {
      @include px2vw(top, 721);
      @include px2vw(left, 210);
    }
    &-paper {
      @include px2vw(top, 607);
      @include px2vw(left, 93);
    }
  }
}
</style>
